/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */

export type AdminsControllerGetAuditLogsV1Category =
	(typeof AdminsControllerGetAuditLogsV1Category)[keyof typeof AdminsControllerGetAuditLogsV1Category];

export const AdminsControllerGetAuditLogsV1Category = {
	ALL: 'ALL',
	CONTENT_MANAGEMENT: 'CONTENT_MANAGEMENT',
	LOGIN: 'LOGIN',
	USER_MANAGEMENT: 'USER_MANAGEMENT',
	PAYMENT: 'PAYMENT',
	REGISTRATION: 'REGISTRATION',
	SYSTEM_EVENT: 'SYSTEM_EVENT',
	SECURITY: 'SECURITY',
	AUDIT: 'AUDIT'
} as const;
